import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Menu } from 'src/app/models/dto/menu';
import { GeolocationService } from 'src/app/services/geolocation.service';
import { Restaurant } from '../../models/dto/restaurant';
import { RestaurantService } from '../../services/restaurant.service';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CryptoService } from 'src/app/services/crypto.service';
import { UiTranslationService } from 'src/app/services/ui-translation.service';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  menu: any = Array<Menu>;
  restaurants: any = Array<any>();
  public loading = false;
  deviceInfo: any = null;
  @ViewChild('miModal', { static: true }) miModal: any = TemplateRef<any>;
 


  constructor(private _restaurantService: RestaurantService, private router: Router, private deviceService: DeviceDetectorService, 
    private geolocationService: GeolocationService, private modalService: NgbModal,  private toastr: ToastrService, 
    public fb: FormBuilder, private _crypto : CryptoService, private i18n: UiTranslationService) {
      
      
    }

  ngOnInit(): void { 
    this.loading = true;
    this.menu = [
      {
        name: "navigation.restaurants",
        type: 1,
        path: "#restaurants"
      },
      {
        name: "navigation.currencyType",
        type: 2,
        path: "#",
        options: [
          {
            name: "MXN"
          },
          {
            name: "USD"
          }
        ]
      }
    ]

    this._restaurantService.getRestaurantsv2().subscribe({
      next: (res: any) => {
        const response = JSON.parse(this._crypto.decrypt(res));
        this.restaurants = response;
        this.loading = false;
      },
      error: (error) => {
        this.loading = false;
        if (error.status === 401) {
          this.toastr.show(this.i18n.translate('messages.requestError'), this.i18n.translate('common.error'));
        } else if (error.status !== 200) {
          this.toastr.show(this.i18n.translate('messages.requestError'), this.i18n.translate('common.error'));
        }
      }
    });
  }  
  
  goMenu(restaurant: any) {
    this.router.navigate(['/menu/' + restaurant["IdRestaurante"] + '/0/0'], {
      state: {
        restaurant: restaurant
      }
    });
  }

  
}
